import { jsxs as h, jsx as t } from "react/jsx-runtime";
import { useMemo as A, useState as T, useEffect as B } from "react";
import { u as c } from "./index-6a632112.mjs";
import { Button as L } from "./button.js";
import { Q as I, s as o, f as S, a as z, e as C, r as M, b as W, c as E } from "./themes-5f0b3c3d.mjs";
import { l as D } from "./lineHeights-72d3110c.mjs";
import { S as k } from "./caretLeft-980c1667.mjs";
import { S as w } from "./caretRight-e0ea6357.mjs";
import { S as H } from "./moreVertical-dc2e97a2.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./types-b577bf77.mjs";
const u = "...", b = (e, r) => {
  const m = r - e + 1;
  return Array.from({ length: m }, (g, a) => a + e);
}, O = ({
  totalCount: e,
  siblingCount: r = 1,
  currentPage: m
}) => A(() => {
  if (r + 5 >= e)
    return b(1, e);
  const x = Math.max(m - r, 1), i = Math.min(m + r, e), d = x > 1, s = i < e - 1, f = 1, p = e;
  if (!d && s) {
    const l = 3 + 2 * r;
    return [...b(1, l - 2), u, e];
  }
  if (d && !s) {
    const l = 3 + 2 * r, $ = b(e - l + 3, e);
    return [f, u, ...$];
  }
  if (d && s) {
    const l = b(x + 1, i - 1);
    return [f, u, ...l, u, p];
  }
}, [e, r, m]), j = c.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${I.tabletAndUp} {
    display: none;
  }
`, U = c(j)`
  gap: ${o["4x"]};
  @media ${I.mobile} {
    max-width: 560px;
  }
  && > button {
    width: 50%;
    min-width: 50%;
    min-height: 40px;
    padding: ${o["1x"]} ${o["6x"]};
    font-family: ${S.inter};
    font-size: ${z.small};
    font-weight: ${C.medium.M.fontWeight};
    line-height: ${D.medium};
    gap: ${o["2x"]};
    > div {
      margin: unset;
    }
  }
`, V = c(j)`
  gap: ${o["2x"]};
`, Q = c.span`
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: ${S.inter};
  font-size: ${z.small};
  font-weight: ${C.medium.M.fontWeight};
  line-height: ${D.medium};
  color: ${({ theme: e }) => e.components.pagination.mobileViewTextColor};
`, F = c.ul`
  display: none;
  margin: unset;
  padding: unset;
  @media ${I.tabletAndUp} {
    display: flex;
    align-items: center;
    list-style-type: none;
    gap: ${o["2x"]};
  }
`, y = c.li`
  height: ${o["10x"]};
  width: ${o["10x"]};
`, v = c.button`
  padding: ${o["2x"]};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: unset;
  border-radius: ${M["2x"]};
  cursor: pointer;
  color: ${({ theme: e }) => e.components.pagination.navButtonColor};
  border: unset;

  &:focus-visible {
    outline: ${W["2x"]} solid
      ${({ theme: e }) => e.components.pagination.outlineColor};
  }

  &:disabled {
    cursor: auto;
    color: ${({ theme: e }) => e.components.pagination.navDisabledColor};
  }

  &:hover:not([disabled]) {
    background-color: ${({ theme: e }) => e.components.pagination.listHoverColor};
  }
`, K = c.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${o["2x"]} ${o["4x"]};
  cursor: pointer;
  border-radius: ${M["2x"]};
  color: ${({ theme: e }) => e.components.pagination.navButtonColor};
  font-family: ${S.inter};
  font-size: ${z.small};
  font-weight: ${C.medium.M.fontWeight};
  line-height: ${D.medium};

  &:focus-visible {
    ${(e) => !e.$isActive && `outline: ${W["2x"]} solid  ${e.theme.components.pagination.outlineColor};
    outline-offset: -2px;
    `}
  }

  ${(e) => {
  if (e.$isActive)
    return `
    background-color: ${e.theme.components.pagination.pageLinkBackgroundColor};
    color: ${E.brandTwilight[0]};
    `;
}};
  &:hover {
    background-color: ${(e) => {
  if (!e.$isActive)
    return e.theme.components.pagination.listHoverColor;
}};
  }
`, _ = c.span`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: ${M["3x"]};
  color: ${({ theme: e }) => e.components.pagination.dotsColor};
  padding: ${o["2x"]} ${o["4x"]};
  box-sizing: border-box;
  && > svg {
    transform: rotate(90deg);
  }
`, se = ({
  itemsPerPage: e = 1,
  totalItems: r = 10,
  siblingCount: m = 2,
  page: g = 1,
  onPageChange: a,
  variant: x = "default"
}) => {
  const [i, d] = T(1), s = Math.ceil(r / e);
  B(() => {
    d(g);
  }, [g]);
  const f = (n) => {
    d(n), a && a(n);
  }, p = () => {
    if (i > 1) {
      const n = i - 1;
      d(n), a && a(n);
    }
  }, l = () => {
    if (i < s) {
      const n = i + 1;
      d(n), a && a(n);
    }
  }, $ = O({
    totalCount: s,
    siblingCount: m,
    currentPage: i
  });
  return /* @__PURE__ */ h("nav", { children: [
    x !== "default" ? /* @__PURE__ */ h(U, { children: [
      /* @__PURE__ */ t(
        L,
        {
          size: "medium",
          buttonType: "secondary",
          buttonColor: "default",
          leftIcon: /* @__PURE__ */ t(k, {}),
          isDisabled: i === 1,
          onClick: p,
          accessibilityOptions: { ariaLabel: "Previous" },
          children: "Previous"
        }
      ),
      /* @__PURE__ */ t(
        L,
        {
          size: "medium",
          buttonType: "secondary",
          buttonColor: "default",
          rightIcon: /* @__PURE__ */ t(w, {}),
          isDisabled: i === s,
          onClick: l,
          accessibilityOptions: { ariaLabel: "Next" },
          children: "Next"
        }
      )
    ] }) : /* @__PURE__ */ h(V, { children: [
      /* @__PURE__ */ t(
        v,
        {
          tabIndex: 0,
          onClick: p,
          disabled: i === 1,
          "aria-label": "prev",
          children: /* @__PURE__ */ t(k, { size: "s" })
        }
      ),
      /* @__PURE__ */ h(Q, { children: [
        i,
        " of ",
        s
      ] }),
      /* @__PURE__ */ t(
        v,
        {
          onClick: l,
          disabled: i === s,
          tabIndex: 0,
          "aria-label": "next",
          children: /* @__PURE__ */ t(w, { size: "s" })
        }
      )
    ] }),
    /* @__PURE__ */ h(F, { children: [
      /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t(
        v,
        {
          tabIndex: 0,
          onClick: p,
          disabled: i === 1,
          "aria-label": "prev",
          children: /* @__PURE__ */ t(k, { size: "s" })
        }
      ) }),
      $.map((n, P) => n === u ? /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t(_, { children: /* @__PURE__ */ t(H, { height: "10px", width: "10px" }) }) }, P) : /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t(
        K,
        {
          $isActive: n === i,
          onClick: () => f(n),
          tabIndex: n === i ? -1 : 0,
          onKeyDown: (R) => {
            (R.code === "Enter" || R.code === "Space") && f(n);
          },
          children: n
        }
      ) }, P)),
      /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t(
        v,
        {
          onClick: l,
          disabled: i === s,
          tabIndex: 0,
          "aria-label": "next",
          children: /* @__PURE__ */ t(w, { size: "s" })
        }
      ) })
    ] })
  ] });
};
export {
  se as Pagination
};
